import { isEmpty } from 'lodash';

export function recommendationFiltersActive(state) {
  const filters = state.filters;
  return !filters.isFavorite && !filters.isHidden && isEmpty(filters.tags);
}

export function getTagFilters(state) {
  return state.filters.tags;
}



// WEBPACK FOOTER //
// ./src/selectors/filteringSelectors.js